<template>
	<div class="match-data_row">
		<div class="match-data_col-1 __red" v-if="isInprogress">
			<span v-if="isSoccer && event.match_time">{{ event.match_time }}'</span>
			<span v-else v-text="event.status_desc"></span>
		</div>
		<div class="match-data_col-1" v-else>
			<div v-if="event.status_desc === 'Матч не начался'">{{ getDate(event.startdate) }}</div>
			<div v-else v-text="event.status_desc"></div>
		</div>
		
		<div class="match-data_col-2" :class="boldClass(score.home, score.away)">
			<img :src="$hostname + event.home_image_ref" alt="">
			<span v-text="event.home_name"></span>
		</div>
		<div class="match-data_col-3" v-text="score.home"></div>
		<div class="match-data_col-4">-</div>
		<div class="match-data_col-5" v-text="score.away"></div>
		<div class="match-data_col-6" :class="boldClass(score.home, score.away)">
			<span v-text="event.away_name"></span>
			<img :src="$hostname + event.away_image_ref" alt="">
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		props: ['event', 'type'],
		
		computed: {
			isInprogress() {
				return this.event.status === 'inprogress';
			},
			isSoccer() {
				return this.type === 'soccer';
			},
			score() {
				if (this.isSoccer) {
					let home = Number(this.event.results.ordinarytime.home);
					let away = Number(this.event.results.ordinarytime.away);
					
					if (home === away) {
						if (this.event.home_score > this.event.away_score) {
							home += 1;
						} else if (this.event.away_score > this.event.home_score) {
							away += 1;
						}
					}
					
					return {
						home, away
					}
				}
				
				return {
					home: this.event.home_score,
					away: this.event.away_score
				}
			}
		},
		
		methods: {
			boldClass(team1, team2) {
				if (Number(team1) > Number(team2) && this.event.status === 'finished') {
					return ['__bold'];
				}
				return [];
			},
			getDate(date) {
				if (moment(date).format('DD-MM-YYYY') === moment().startOf('day').format('DD-MM-YYYY')) {
					return moment(date).format('HH:mm');
				}
				return moment(date).format('DD.MM');
			},
		}
	}
</script>

<style scoped>

</style>